var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"api-key":"cemfgr65ivw46gvn9c69nbvsjeksdhepzjouk75kzh1u8ypu","init":{        
     height: 500,
     menubar: false,
     toolbar: 'bold italic underline |  undo redo',
     content_css: 'dark',
    }},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "),_c('input',{attrs:{"name":_vm.name,"type":"hidden"},domProps:{"value":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }